import { combineReducers } from 'redux';
import { commercials } from './commercials/commercials.reducer';
import { report } from './report/report.reducer';
export const budenterprise = combineReducers({
    commercials,
    report
});